import Vue from 'vue'

export default {
  getDomains ({ commit }) {
    return Vue.api.get('engine/domains')
      .then((res) => commit('init', { domains: res.data }))
  },
  createDomain ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/domains', data))
      .then((res) => commit('domain', res.data))
  },
  checkDomain ({ commit }, domain) {
    return Vue.api.post('engine/domains/check', { domain }).then((res) => res.data)
  },
  removeDomain ({ commit, state, dispatch }, data) {
    commit('domain', data.id)
    return dispatch('getApiVersion', data.instanceId).then((api) => api.delete('engine/domains/' + data.name + '/' + data.applicationId))
  },
  moveDomain ({ commit }, data) {
    return Vue.api.post('engine/domains/' + data.name + '/move', data)
      .then((res) => commit('domain', res.data))
  },
  regenerateDomain ({ commit }, data) {
    return Vue.api.put('engine/domains/' + data.name + '/regenerate')
  },
  getDomainRedirections ({ commit }, domain) {
    return Vue.api.get('engine/domains/' + domain + '/redirections').then((res) => res.data)
  },
  createDomainRedirection ({ commit }, data) {
    return Vue.api.post('engine/domains/' + data.domainName + '/redirections', data).then((res) => res.data)
  },
  updateDomainRedirection ({ commit }, data) {
    return Vue.api.put('engine/domains/' + data.domainName + '/redirections/' + data.id, data)
  },
  removeDomainRedirection ({ commit }, data) {
    return Vue.api.delete('engine/domains/' + data.domainName + '/redirections/' + data.id)
  }
}
